import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {

  const socialLinks = [
    {
      icon: Instagram,
      name: 'Instagram',
      url: 'https://www.instagram.com/banyumasultratrail/'
    },
    {
      icon: Facebook,
      name: 'Facebook',
      url: '#'
    },
    {
      icon: Twitter,
      name: 'Twitter',
      url: '#'
    }
  ];

  const navLinks = [
    { name: "Lomba", path: "/races" },
    { name: "Jadwal", path: "/schedule" },
    { name: "Kontak", path: "/contact" }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* LOGO */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center space-x-2 mb-4">
              <Mountain className="h-8 w-8 text-primary" />
              <span className="text-xl font-bold">Banyumas Ultra</span>
            </div>
            <p className="text-muted-foreground text-center md:text-left">
              Taklukkan jalur menantang di lereng kaki Gunung Slamet
            </p>
          </div>

          {/* NAV */}
          <div className="text-center">
            <p className="font-semibold text-foreground mb-4">
              Navigasi Cepat
            </p>

            <ul className="space-y-2">
              {navLinks.map(link => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="text-center md:text-right">
            <p className="font-semibold text-foreground mb-4">
              Ikuti Kami
            </p>

            <div className="flex justify-center md:justify-end space-x-4">

              {socialLinks.map(social => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  <social.icon className="h-6 w-6" />
                  <span className="sr-only">{social.name}</span>
                </a>
              ))}

            </div>
          </div>

        </div>

        {/* COPYRIGHT */}
        <div className="mt-8 pt-8 border-t border-border text-center text-muted-foreground text-sm">
          <p>
            &copy; {new Date().getFullYear()} Banyumas Ultra. Semua Hak Cipta Dilindungi.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;